export const invoiceListDemoData = [
    {
        id: 24,
        firstName: 'Yeasin',
        lastName: 'Arafat',
        email: '',
        phone: '',
        invoiceTitle: 'Purchase',
        timeIssue: 1701342888,
        timeDue: 1701429288,
        timeCanceled: 0,
        note: '',
        status: 'pending',
        timeCreated: 1701342888,
        timeUpdated: 1701342888,
        demo: true
    },
    {
        id: 26,
        firstName: 'Yeasin',
        lastName: 'Arafat',
        email: '',
        phone: '',
        invoiceTitle: 'Purchase',
        timeIssue: 1701361047,
        timeDue: 1701447447,
        timeCanceled: 0,
        note: '',
        status: 'pending',
        timeCreated: 1701361047,
        timeUpdated: 1701361047,
        demo: true
    }
];

export default null;
